function VoiceVoteLiked({ isLiked, color }) {
    return (
        <div>
            {isLiked ? (
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M14.56 1.8134C17.5583 1.82799 19.9854 4.25502 20 7.25341C20 12.7467 10 18.1867 10 18.1867C10 18.1867 0 12.6667 0 7.25341C0 4.249 2.43555 1.8134 5.44002 1.8134C7.27915 1.79905 8.99854 2.72408 10 4.26671C11.0084 2.73158 12.7233 1.80896 14.56 1.8134Z"
                        fill={color}
                    />
                </svg>
            ) : (
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M14.3291 1.72109C12.6607 1.71217 11.0747 2.4449 9.99998 3.72107C8.93203 2.43617 7.34156 1.70137 5.67085 1.72109C2.53892 1.72109 0 4.26001 0 7.39195C0 12.7591 9.36708 17.9995 9.74684 18.2021C9.90006 18.3045 10.0999 18.3045 10.2532 18.2021C10.6329 17.9995 20 12.835 20 7.39195C20 4.26001 17.461 1.72109 14.3291 1.72109ZM9.99998 17.1894C8.53162 16.3287 1.01266 11.7464 1.01266 7.39195C1.01266 4.8193 3.09821 2.7337 5.6709 2.7337C7.24634 2.71301 8.7207 3.50766 9.56963 4.83495C9.74199 5.07264 10.0745 5.1256 10.3121 4.95319C10.3575 4.92024 10.3975 4.88036 10.4304 4.83495C11.8383 2.68176 14.7252 2.07759 16.8784 3.48552C18.1965 4.34742 18.9899 5.81699 18.9873 7.3919C18.9873 11.797 11.4683 16.354 9.99998 17.1894Z"
                        fill={color}
                    />
                </svg>
            )}
        </div>
    );
}

export default VoiceVoteLiked;
